/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PopupDto } from '../../models/popup-dto';

export interface PopupClientControllerFindByIdV1$Params {
  id: string;
}

export function popupClientControllerFindByIdV1(http: HttpClient, rootUrl: string, params: PopupClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
  const rb = new RequestBuilder(rootUrl, popupClientControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PopupDto>;
    })
  );
}

popupClientControllerFindByIdV1.PATH = '/api/v1/popups/client/{id}';
